import { FC } from "react";

interface FavIconProps {
    website: string | null | undefined;
    className?: string;
}

export const FavIcon: FC<FavIconProps> = (props) => {
    if (!props.website) return null;

    return (
        <img src={`https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&size=32&url=${props.website}`} className={props.className} />
    );
};